import { defineMeta } from '@/registry/types';

export const radioMeta = defineMeta({
  name: 'Radio',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Single-select control for mutually-exclusive options. Themed MUI Radio + RadioGroup.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Radio',
  muiDocs: 'https://mui.com/material-ui/react-radio-button/',
  a2uiEquivalent: 'RadioGroup',
  importPath: '@/atoms/Radio',
  optionalProps: ['checked', 'value', 'disabled', 'size', 'onChange'],
  supportedStates: ['default', 'selected', 'disabled', 'focus'],
  designTokens: ['colors'],
  accessibility: [
    'Always group Radios in a RadioGroup with an associated FormLabel.',
    'Keyboard: arrow keys move selection within the group.',
  ],
  usageExamples: ['<RadioGroup><FormControlLabel value="a" control={<Radio />} label="A" /></RadioGroup>'],
  antiPatterns: ['Do not use a single Radio in isolation.', 'Do not use Radio for on/off (use Switch).'],
  llmSafe: true,
  whenToUse: ['Choosing one option from a small set (2-6)'],
  whenNotToUse: ['Many options (use Select)', 'Multiple selections (use Checkbox)'],
});

export default radioMeta;
